// extracted by mini-css-extract-plugin
export default {"noData":"no-data_noData__s7DTI"};